// extracted by mini-css-extract-plugin
export default {"badge":"fairness_badge__9OBJq"};